class SaffiomeBuy extends HTMLElement {
  constructor() {
    super();
        if (this.hasAttribute('data-sf-soon-mode')) return; // coming-soon page: no form to wire
    this.form = this.querySelector('form');
    this.planInput = this.querySelector('input[name="selling_plan"]');
    this.qtyInput = this.querySelector('input[name="quantity"]');
    this.planRadios = [...this.querySelectorAll('input[data-sf-plan]')];
    this.qtyRadios = [...this.querySelectorAll('input[data-sf-qty]')];
    this.priceAmount = this.querySelector('[data-sf-price-amount]');
    this.priceCadence = this.querySelector('[data-sf-price-cadence]');
    this.priceCompare = this.querySelector('[data-sf-price-compare]');
    this.priceUnit = this.querySelector('[data-sf-price-unit]');
    this.totalLine = this.querySelector('[data-sf-total]');
    this.cta = this.querySelector('[data-sf-cta]');
    this.ctaLabel = this.querySelector('[data-sf-cta-label]');
    this.reassureCadence = this.querySelector('[data-sf-reassure-cadence]');
    this.oneTimeNote = this.querySelector('[data-sf-one-time-note]');
    this.sticky = document.querySelector('[data-sf-sticky]');
    this.stickyPrice = this.sticky ? this.sticky.querySelector('[data-sf-sticky-price]') : null;
    this.stickyTitle = this.sticky ? this.sticky.querySelector('.sf-sticky__title') : null;
    this.stickyCta = this.sticky ? this.sticky.querySelector('[data-sf-sticky-cta]') : null;
    this.currency = this.dataset.currency || 'AUD';
    this.locale = this.dataset.locale || 'en-AU';
    this.labels = {
      subscribe: this.dataset.labelSubscribe || 'Start my subscription',
      oneTime: this.dataset.labelOneTime || 'Add to cart',
      child: this.dataset.labelChild || 'child',
      children: this.dataset.labelChildren || 'children',
      perDay: this.dataset.labelPerDay || 'about {amount} a day',
      perServe: this.dataset.labelPerServe || '{amount} a sachet',
      added: this.dataset.labelAdded || 'Added'
    };
    this.daysSupply = Number(this.dataset.daysSupply || 0);
    this.servesPerBox = Number(this.dataset.servesPerBox || 0);
    this.formatter = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency });
    // Whole dollars print without cents ($119, not $119.00), as the rest of the site writes them; $3.30 keeps its cents.
    this.formatterWhole = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCartUpdate = this.onCartUpdate.bind(this);
  }

  connectedCallback() {
        if (this.hasAttribute('data-sf-soon-mode')) return;
    this.planRadios.forEach((r) => r.addEventListener('change', this.onChange));
    this.qtyRadios.forEach((r) => r.addEventListener('change', this.onChange));
    if (this.form) this.form.addEventListener('submit', this.onSubmit);
    if (this.sticky) this.setupSticky();
    this.prepareStates();
    this.render();
  }

  disconnectedCallback() {
        if (this.hasAttribute('data-sf-soon-mode')) return;
    this.planRadios.forEach((r) => r.removeEventListener('change', this.onChange));
    this.qtyRadios.forEach((r) => r.removeEventListener('change', this.onChange));
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    if (this.observer) this.observer.disconnect();
    if (this.unsubscribeCart) this.unsubscribeCart();
  }

  get plan() {
    const checked = this.planRadios.find((r) => r.checked);
    if (!checked) return null;
    return {
      id: checked.dataset.sfPlan,
      type: checked.dataset.sfPlanType,
      price: Number(checked.dataset.sfPrice),
      compare: Number(checked.dataset.sfCompare || 0),
      cadence: checked.dataset.sfCadence || ''
    };
  }

  get quantity() {
    const checked = this.qtyRadios.find((r) => r.checked);
    return checked ? Number(checked.value) : Number(this.qtyInput ? this.qtyInput.value : 1) || 1;
  }

  money(cents) {
    return (Math.round(cents) % 100 === 0 ? this.formatterWhole : this.formatter).format(cents / 100);
  }

  onChange(event) {
    const isPlan = event.target.hasAttribute('data-sf-plan');
    this.render();
    if (isPlan) this.markPlan(event.target);
    else this.popQuantity(event.target);
    this.emit(isPlan ? 'plan selected' : 'quantity changed', {
      plan: this.plan ? this.plan.type : 'none',
      quantity: this.quantity
    });
  }

  onSubmit(event) {
    // Coming soon mode (Nathan, 14 Oct 2026): the form never reaches the cart; it opens the sign-up box.
    if (this.form && this.form.hasAttribute('data-sf-capture')) {
      if (event) event.preventDefault();
      const id = this.cta ? this.cta.getAttribute('data-sf-soon-open') : null;
      if (id && window.sfSoon) window.sfSoon.open(id, this.cta);
      return;
    }
    this.emit('add to cart', { plan: this.plan ? this.plan.type : 'none', quantity: this.quantity });
  }

  render() {
    const plan = this.plan;
    const qty = this.quantity;
    if (this.qtyInput) this.qtyInput.value = String(qty);
    if (this.planInput) {
      const isSubscription = plan && plan.type !== 'one_time' && plan.id;
      this.planInput.value = isSubscription ? plan.id : '';
      this.planInput.disabled = !isSubscription;
    }
    if (!plan) return;
    const isSubscription = plan.type !== 'one_time';
    if (this.priceAmount) this.priceAmount.textContent = this.money(plan.price);
    if (this.priceCadence) this.priceCadence.textContent = isSubscription ? plan.cadence : '';
    if (this.priceCompare) {
      const show = isSubscription && plan.compare > plan.price;
      this.priceCompare.textContent = show ? this.money(plan.compare) : '';
      this.priceCompare.hidden = !show;
    }
    if (this.priceUnit) {
      let unit = '';
      if (this.daysSupply > 0) unit = this.labels.perDay.replace('{amount}', this.money(Math.round(plan.price / this.daysSupply)));
      else if (this.servesPerBox > 0) unit = this.labels.perServe.replace('{amount}', this.money(Math.round(plan.price / this.servesPerBox)));
      this.priceUnit.textContent = unit;
      this.priceUnit.hidden = unit === '';
    }
    if (this.totalLine) {
      // The running total counts people, so it only means anything when there is a
      // "how many" step to count them with. The Family Pack has no such step: one pack
      // covers a household, and the line read "1 child" until 9 Sep 2026.
      const hasQtyStep = this.qtyRadios.length > 0;
      const noun = qty === 1 ? this.labels.child : this.labels.children;
      const total = this.money(plan.price * qty);
      this.totalLine.textContent = hasQtyStep && (qty > 1 || isSubscription)
        ? `${qty} ${noun}: ${total}${isSubscription ? ' ' + plan.cadence : ''}`
        : '';
      this.totalLine.hidden = this.totalLine.textContent === '';
    }
    // Liquid renders "Sold out" and disables the button when the variant is unavailable, or
    // when a bundle cannot be made from its components. Overwriting that here left a dead
    // button reading "Start my subscription" with nothing to say why.
    if (this.ctaLabel && !(this.cta && this.cta.disabled)) {
      this.ctaLabel.textContent = isSubscription ? this.labels.subscribe : this.labels.oneTime;
    }
    if (this.reassureCadence) this.reassureCadence.hidden = !isSubscription;
    if (this.oneTimeNote) this.oneTimeNote.hidden = isSubscription;
    if (this.stickyPrice) this.stickyPrice.textContent = `${this.money(plan.price * qty)}${isSubscription ? ' ' + plan.cadence : ''}`;
    // The bar names the chosen plan ("Founders Rate"), not the product, whose name it cut off (PR 1, 25 Oct 2026),
    // and its button says what the main button says once buying opens, instead of "Buy".
    const checked = this.planRadios.find((r) => r.checked);
    if (this.stickyTitle && checked && checked.dataset.sfPlanShort) this.stickyTitle.textContent = checked.dataset.sfPlanShort;
    if (this.stickyCta && !this.stickyCta.disabled) this.stickyCta.textContent = isSubscription ? this.labels.subscribe : this.labels.oneTime;
  }

  setupSticky() {
    if (!('IntersectionObserver' in window) || !this.cta) return;
    const button = this.sticky.querySelector('[data-sf-sticky-cta]');
    if (button) {
      button.addEventListener('click', () => {
        this.emit('sticky bar used', {});
        if (this.form && this.form.hasAttribute('data-sf-capture')) return; // its data-sf-soon-open opens the sign-up box
        if (this.form && this.form.requestSubmit) this.form.requestSubmit();
        else if (this.cta) this.cta.click();
      });
    }
    // The bar shows only while no part of the buy box is on screen, so it never sits over the kids buttons, the
    // plan cards or the main button (PR 1, 25 Oct 2026: 63 overlaps in a 201-step scroll test under the old rule,
    // which watched the main button alone).
    const area = this.closest('.sf-buy') || this;
    this.observer = new IntersectionObserver((entries) => {
      const onScreen = entries.some((e) => e.isIntersecting);
      this.sticky.dataset.visible = onScreen ? 'false' : 'true';
    });
    this.observer.observe(area);
  }

  /* State classes for saffiome-motion.css. Visual only: pricing, quantity, plan and sticky logic are untouched. */
  prepareStates() {
    const stickyCta = this.sticky ? this.sticky.querySelector('[data-sf-sticky-cta]') : null;
    this.ctaTargets = [this.cta, stickyCta].filter(Boolean);
    this.ctaTargets.forEach((el) => { el.dataset.sfAddedLabel = this.labels.added; });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
    }
  }

  markPlan(input) {
    this.planRadios.forEach((r) => {
      const card = r.closest('.sf-choice');
      if (card && r !== input) card.classList.remove('is-selected');
    });
    this.flash(input.closest('.sf-choice'), 'is-selected', 0);
  }

  popQuantity(input) {
    this.flash(input.closest('.sf-choice'), 'is-popped', 320);
  }

  onCartUpdate(data) {
    if (!data || data.source !== 'product-form') return;
    const idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    if (idInput && data.productVariantId && String(data.productVariantId) !== String(idInput.value)) return;
    (this.ctaTargets || []).forEach((el) => this.flash(el, 'is-added', 1600));
    this.flash(document.querySelector('#cart-icon-bubble'), 'is-bumped', 640);
  }

  flash(el, className, ms) {
    if (!el) return;
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);
    const key = 'sfTimer_' + className;
    clearTimeout(el[key]);
    if (ms > 0) el[key] = setTimeout(() => el.classList.remove(className), ms);
  }

  emit(name, detail) {
    document.dispatchEvent(new CustomEvent('saffiome:event', { detail: Object.assign({ name: name, product: this.dataset.productHandle }, detail) }));
  }
}

if (!customElements.get('saffiome-buy')) customElements.define('saffiome-buy', SaffiomeBuy);
